// test2234
(2234 && 0);
